<template>
  <div class="home">
    <!-- 轮播图开始 -->
    <div style="position: relative">
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <img :src="item.backImg" alt="" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <!-- 新闻通知 -->
      <div class="noticeBox" v-if="noticeList.length > 0">
        <div class="notice-main">
          <div class="notice-title">
            <span>行业资讯</span>
          </div>
          <div class="noticeItem">
            <ul
              class="marquee_list"
              :style="{ top: -num + 'px' }"
              :class="{ marquee_top: num }"
            >
              <li
                v-for="(item, index) in noticeList"
                :key="index"
                @click="tonotice(item.pressId, item.twoTitle)"
              >
                <span class="noticeCont">{{ item.twoTitle }}</span>
                <span class="noticeTime"
                  >[{{ item.createTime | dateFilter("YYYY-MM-DD") }}]</span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 新闻通知 -->
      <div class="ImageBox" v-for="(item, index) in swiperList" :key="index">
        <div class="leftImage" v-if="index == nowIndex">
          <img :src="item.leftImg" alt="" />
        </div>
        <div class="rightImage" v-if="index == nowIndex">
          <img :src="item.rightImg" alt="" />
        </div>
      </div>
    </div>
    <!-- 轮播图结束 -->
    <!-- 汇聚行业智慧 助力企业腾飞 -->
    <div class="ProductBox">
      <div class="Product_mian">
        <div class="Product-title">汇聚行业智慧 助力企业腾飞</div>
        <div class="undefind"></div>
        <div class="Product_text">Product display</div>
        <div class="Product_ImageBox">
          <div class="Image-L">
            <img :src="ImageOne.img" alt="" />
            <div class="animationItem">
              <div class="link_icon">
                <img src="../assets/img/icon_link.png" alt="" />
              </div>
              <div class="title">{{ ImageOne.title }}</div>
              <!-- <div class="dsrc">{{ImageOne.title}}</div> -->
            </div>
          </div>
          <div class="Image_R">
            <div v-for="(item, index) in ImgList" :key="index">
              <div class="ImageItem">
                <img :src="item.img" alt="" />
                <div class="animationItem">
                  <div class="link_icon">
                    <img src="../assets/img/icon_link.png" alt="" />
                  </div>
                  <div class="title">{{ item.title }}</div>
                  <!-- <div class="dsrc">{{item.title}}</div> -->
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="industryBox">
            <div class="industry-title">行业资讯</div>
            <div class="undfined"></div>
            <div class="title_En">Industry Information </div>
            <div class="content">致力于IT建设服务：包含机房建设、安防监控建设、数据安全备份系统建设、业务系统安全建设。数据防泄密系统建设、网络系统安全设计建设、系统运维安全平台建设；网络系统建设、业务系统优化建设、移动…</div>
            <div class="btnBox">
              <div class="btntext">了解更多</div>
              <i class="el-icon-arrow-right"></i>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 分类 -->
    <div class="classificationBox">
      <div class="classification_main" v-if="classNameList.length > 0">
        <div class="classNavList">
          <div
            class="classNavItem"
            :class="{ currentColor: current == index }"
            v-for="(item, index) in classNameList"
            :key="index"
            @click="clickItem(index)"
          >
            {{ item.homeShowClassPojo.className }}
          </div>
        </div>
        <div>
          <div>
            <div class="titleBox">
              <div class="classification_title">
                {{ classNameList[current].homeShowClassPojo.hostTitle }}
              </div>
              <div class="undfined"></div>
              <div class="dsrctext">
                {{ classNameList[current].homeShowClassPojo.sonTitle }}
              </div>
            </div>
            <div class="classImageList">
              <div
                class="classImageItem"
                v-for="(ptem, pndex) in classNameList[current]
                  .homeShowInfoPojoList"
                :key="pndex"
              >
                <a class="classImage" target="_blank" :href="ptem.link"
                  ><img :src="ptem.img" alt=""
                /></a>
                <div class="className">{{ ptem.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 分类 -->
    <!-- 联系我们 -->
    <div class="contactBox">
      <div class="contactMain">
        <div class="contactTitleBox">
          <div class="contact_title">联系我们</div>
          <div class="undfind"></div>
          <div class="contact_En">contact us</div>
          <div class="contacttext" v-html="WebsiteInfo.introduce"></div>
        </div>
        <div class="addressBox">
          <div class="ItemBox">
            <i class="el-icon-location"></i>
            <div class="itemName">{{ WebsiteInfo.addressInfo }}</div>
          </div>
          <div class="ItemBox">
            <i class="el-icon-phone"></i>
            <div class="itemName">{{ WebsiteInfo.phone }}</div>
          </div>
          <div class="ItemBox">
            <i class="el-icon-message"></i>
            <div class="itemName">{{ WebsiteInfo.email }}</div>
          </div>
        </div>
        <div class="mapBox">
          <baidu-map
            :center="center"
            :zoom="zoom"
            @ready="handler"
            style="height: 300px; width: 100%"
            @click="getClickInfo"
            :scroll-wheel-zoom="true"
          ></baidu-map>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
  </div>
</template>

<script>
// @ is an alias to /src
import Swiper from "swiper";
var timer = null;
var timer1 = null;
export default {
  name: "Home",
  data() {
    return {
      page: 1,
      limit: 10,
      swiperList: [],
      currentMenu: 0,
      currentIndex: -1,
      isanimation: false,
      ImgList: [],
      ImageOne: {},
      ltimeInfo: [],
      nowIndex: 0,
      classNameList: [],
      current: 0,
      WebsiteInfo: {},
      center: { lng: 109.45744048529967, lat: 36.49771311230842 },
      zoom: 13,
      num: 0,
      noticeList: [],
    };
  },
  created() {
    this.getSwiper();
    this.getImageList();
    this.getClassName();
    this.getWebsiteInfo();
    this.getNoticeList();
  },
  mounted() {
    let _this = this;
    new Swiper(".swiper-container", {
      loop: false,
      // 如果需要分页器
      pagination: ".swiper-pagination",
      observer: true, //修改swiper自己或子元素时，自动初始化swiper
      observeParents: true, //修改swiper的父元素时，自动初始化swiper
      // 如果需要滚动条
      // scrollbar: '.swiper-scrollbar',
      //如果需要自动切换海报
      autoplay: 3000,
      autoplayDisableOnInteraction: false,
      onSlideChangeEnd: function (swiper) {
        // alert(swiper.activeIndex) //切换结束时，告诉我现在是第几个slide
        if (
          swiper.activeIndex == 1 ||
          swiper.activeIndex == _this.swiperList.length + 1
        ) {
          _this.nowIndex = 0;
        } else if (swiper.activeIndex == 0) {
          _this.nowIndex = _this.swiperList.length - 1;
        } else {
          _this.nowIndex = Number(swiper.activeIndex) - 1;
        }
      },
      onSlideChangeStart: function (swiper) {
        _this.nowIndex = -1;
      },
    });
  },
  methods: {
    tonotice(id, name) {
      // console.log(id)
      this.$router.push({
        path: "/News-detail",
        query: { pressId: id, title: name },
      });
    },
    //新闻通知
    getNoticeList() {
      let url = "/pressController/front/searchPressList";
      this.$axios.get(url).then((res) => {
        console.log(res);
        this.noticeList = res.data.data;
        if (this.noticeList.length > 0) {
          this.showMarquee(this.num);
        }
      });
    },
    showMarquee(num) {
      // let clientWidth = document.documentElement.clientWidth;
      // console.log(clientWidth)
      this.noticeList.push(this.noticeList[0]);
      var max = this.noticeList.length;
      // var that = this;
      var marqueetimer = setInterval(() => {
        num++;
        if (num >= max) {
          num = 0;
        }
        this.num = num * 60;
      }, 2000);
    },
    handler({ BMap, map }) {
      console.log(this.WebsiteInfo);
      var point = new BMap.Point(
        this.WebsiteInfo.longitude,
        this.WebsiteInfo.latitude
      );
      map.centerAndZoom(point, 13);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
      var circle = new BMap.Circle(point, 6, {
        strokeColor: "Red",
        strokeWeight: 6,
        strokeOpacity: 1,
        Color: "Red",
        fillColor: "#f03",
      });
      map.addOverlay(circle);
    },
    getClickInfo(e) {
      // console.log(e)
      this.center.lng = e.point.lng;
      this.center.lat = e.point.lat;
    },
    // 网站信息
    getWebsiteInfo() {
      let url = "/webInfoController/searchWebInfo";
      this.$axios.get(url).then((res) => {
        console.log(res);
        this.WebsiteInfo = res.data.data;
        this.center.lng = res.data.data.longitude;
        this.center.lat = res.data.data.latitude;
      });
    },
    clickItem(index) {
      this.current = index;
    },
    mouseleaveIage() {
      this.isanimation = false;
    },
    mouseenterImage() {
      this.isanimation = true;
    },
    mouseleave() {
      console.log(123);
      // this.isanimation = false
      this.currentIndex = -1;
    },
    mouseenter(index) {
      console.log(index);
      clearTimeout(timer);
      this.currentIndex = index;
    },
    //分类展示
    getClassName() {
      let url = "/homeShowController/front/searchHomeShow";
      this.$axios.get(url).then((res) => {
        console.log(res);
        this.classNameList = res.data.data;
      });
    },
    //图片
    getImageList() {
      let url = "/photographController/front/searchList";
      this.$axios.get(url).then((res) => {
        console.log(res);
        this.ImageOne = res.data.data[0];
        this.ImgList = res.data.data.filter((item, index) => {
          return index >= 1;
        });
        // console.log(this.ImgList)
      });
    },
    clickMenu(id, index) {
      this.currentMenu = index;
      this.getrealtimeInfo(id);
    },
    //轮播图
    getSwiper() {
      let url = "/slideshowController/front/searchSlideshow";
      this.$axios.get(url).then((res) => {
        // console.log(res)
        if (res.data.code == 20000) {
          this.swiperList = res.data.data;
        }
      });
    },
  },
};
</script>

<style lang="less">
.home {
  // padding-top: 142px;
  .swiper-container {
    width: 100%;
    height: auto;
    // background: coral;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .noticeBox {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 60px;
    background: rgba(0, 0, 0, 0.4);
    z-index: 20;
    // padding: 0 32px;
    box-sizing: border-box;
  }
  .notice-main {
    display: flex;
    align-items: center;
    margin: 0 auto;
    height: 60px;
    width: 1200px;
    margin: 0 auto;
  }
  .noticeItem {
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    flex: 1;
    overflow: hidden;
  }
  .marquee_box {
    display: block;
    position: relative;
    width: 100%;
    height: 50px; /*关键样式*/
    overflow: hidden;
  }
  .marquee_list {
    /* display: block; */
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
  }
  .marquee_top {
    transition: top 0.5s;
  } /*关键样式*/
  .marquee_list li {
    height: 60px; /*关键样式*/
    line-height: 60px;
    font-size: 14px;
    /* padding-left: 20px; */
    /* background-color: #fff; */
    list-style-type: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }
  .notice-title {
    font-size: 20px;
    color: #e5e5e5;
    padding: 0 8px;
    border-right: 3px solid #e5e5e5;
    margin-right: 20px;
  }
  .noticeCont {
    font-size: 20px;
    color: #cccaca;
  }
  .noticeTime {
    color: rgb(180, 178, 178);
    margin-left: 20px;
    font-size: 20px;
  }
  .ImageBox {
    .leftImage {
      position: absolute;
      width: 300px;
      height: 300px;
      left: 100px;
      top: 50%;
      transform: translateY(-50%);
      // border: 1px solid #1373CF;
      animation: left 0.5s linear 0.2s forwards;
      opacity: 0;
      z-index: 2;
      img {
        width: 100%;
        height: 100%;
      }
    }
    @keyframes left {
      0% {
        left: 100px;
        opacity: 0;
      }
      100% {
        left: 360px;
        opacity: 1;
      }
    }
    .rightImage {
      position: absolute;
      width: 300px;
      height: 300px;
      right: 100px;
      top: 50%;
      transform: translateY(-50%);
      // border: 1px solid #1373CF;
      animation: right 0.5s linear 0.2s forwards;
      opacity: 0;
      z-index: 2;
      img {
        width: 100%;
        height: 100%;
      }
    }
    @keyframes right {
      0% {
        right: 100px;
        opacity: 0;
      }
      100% {
        right: 360px;
        opacity: 1;
      }
    }
  }
  // 汇聚行业智慧 助力企业腾飞
  .ProductBox {
    width: 100%;
    height: 702px;
    // padding: 60px 360px;
    .Product_mian {
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 1200px;
      height: 100%;
      .Product-title {
        font-size: 30px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #333333;
      }
      .undefind {
        width: 60px;
        height: 2px;
        background: #1373cf;
        margin: 10px 0;
      }
      .Product_text {
        font-size: 16px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #cccccc;
        text-transform: uppercase;
      }
      .Product_ImageBox {
        display: flex;
        justify-content: space-between;
        margin-top: 44px;
        .Image-L {
          position: relative;
          width: 588px;
          height: 470px;
          margin-right: 24px;
          // background: coral;
          cursor: pointer;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .Image-L:hover .animationItem {
          opacity: 0.68;
        }
        .animationItem {
          position: absolute;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          top: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          background: #1373cf;
          transition: 0.5s ease;
          .link_icon {
            width: 46px;
            height: 46px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .title {
            width: 90%;
            font-size: 18px;
            font-family: NotoSansHans-Medium, NotoSansHans;
            font-weight: 500;
            color: #ffffff;
            padding: 19px 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            text-align: center;
          }
          .dsrc {
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #ffffff;
          }
        }
        .Image_R {
          display: flex;
          flex-wrap: wrap;
          width: calc(1200px - 588px);
          height: 100%;
          overflow: hidden;
          .ImageItem {
            position: relative;
            width: 282px;
            height: 223px;
            // background: coral;
            margin-bottom: 16px;
            margin-right: 20px;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .ImageItem:hover .animationItem {
            opacity: 0.68;
          }
          .animationItem {
            position: absolute;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            opacity: 0;
            background: #1373cf;
            transition: 0.5s ease;
            .link_icon {
              width: 46px;
              height: 46px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .title {
              font-size: 18px;
              font-family: NotoSansHans-Medium, NotoSansHans;
              font-weight: 500;
              color: #ffffff;
              padding: 19px 0;
            }
            .dsrc {
              font-size: 14px;
              font-family: NotoSansHans-Regular, NotoSansHans;
              font-weight: 400;
              color: #ffffff;
            }
          }
          // .location0{
          //     position: absolute;
          //     top: 0;
          //     left: 0;
          //   }
          //   .location1{
          //     position: absolute;
          //     top: 0;
          //     right: 0;
          //   }
          //   .location2{
          //     position: absolute;
          //     bottom: 0;
          //     left: 0;
          //   }
          //   .location3{
          //     position: absolute;
          //     bottom: 0;
          //     right: 0;
          //   }
        }
        .industryBox {
          width: 282px;
          padding: 36px 30px;
          box-sizing: border-box;
          background: rgba(19, 115, 207, 0.04);
          .industry-title {
            font-size: 30px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #333333;
          }
          .undfined {
            width: 63px;
            height: 2px;
            background: #1373cf;
            margin: 10px 0;
          }
          .title_En {
            font-size: 16px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #cccccc;
            text-transform: uppercase;
          }
          .content {
            width: 222px;
            height: 223px;
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            margin-top: 14px;
          }
          .btnBox {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 158px;
            height: 36px;
            background: #1373cf;
            margin-top: 57px;
            cursor: pointer;
            .btntext {
              font-size: 18px;
              font-family: NotoSansHans-Regular, NotoSansHans;
              font-weight: 400;
              color: #ffffff;
            }
            .el-icon-arrow-right {
              color: #fff;
            }
          }
        }
      }
    }
  }
  // 分类
  .classificationBox {
    padding: 44px 0;
    background: #f0f2f5;
    .classification_main {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 1200px;
      margin: 0 auto;
      .classNavList {
        display: flex;
        // width: 896px;
        // height: 50px;
        // margin: 0 auto;
        .classNavItem {
          width: 180px;
          height: 50px;
          font-size: 18px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          // color: #FFFFFF;
          background: #fff;
          line-height: 50px;
          text-align: center;
          border-right: 1px solid #e6e8ed;
          box-sizing: border-box;
          cursor: pointer;
        }
        // .classNavItem:hover:not(.currentColor){
        //   background: #8bc3f7;
        //   color: #fff;
        // }
        .currentColor {
          background: #1373cf;
          color: #fff;
        }
      }
      .titleBox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .classification_title {
          font-size: 30px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #333333;
          margin-top: 44px;
        }
        .undfined {
          width: 60px;
          height: 2px;
          background: #1373cf;
          margin: 10px 0;
        }
        .dsrctext {
          font-size: 16px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #cccccc;
        }
      }
      .classImageList {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 36px;
        .classImageItem {
          margin-right: 24px;
          width: 282px;
          // padding:0 12px;
          // box-sizing: border-box;
          cursor: pointer;
          .classImage {
            display: block;
            width: 100%;
            height: 240px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .classImage:hover {
            opacity: 0.8;
          }
          .className {
            font-size: 18px;
            font-family: NotoSansHans-Medium, NotoSansHans;
            font-weight: 500;
            color: #333333;
            padding: 24px 0;
            text-align: center;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .classImageItem:nth-child(4n + 4) {
          margin-right: 0;
        }
      }
    }
  }
  // 分类
  .contactBox {
    padding: 60px 0;
    .contactMain {
      width: 1200px;
      margin: 0 auto;
      .contactTitleBox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .contact_title {
          font-size: 30px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #333333;
        }
        .undfind {
          width: 60px;
          height: 2px;
          background: #1373cf;
          margin: 10px 0;
        }
        .contact_En {
          font-size: 16px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #cccccc;
          text-transform: uppercase;
        }
        .contacttext {
          font-size: 14px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
          padding: 14px 0 36px 0;
          text-align: center;
        }
      }
      .addressBox {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 18px;
        font-family: NotoSansHans-Medium, NotoSansHans;
        font-weight: 500;
        color: #333333;
        .ItemBox {
          display: flex;
          align-items: center;
          .el-icon-location {
            color: #1373cf;
            font-size: 30px;
          }
          .el-icon-phone {
            color: #1373cf;
            font-size: 30px;
          }
          .el-icon-message {
            color: #1373cf;
            font-size: 30px;
          }
          .itemName {
            margin-left: 12px;
          }
        }
      }
      .mapBox {
        width: 1200px;
        height: 300px;
        // background: burlywood;
        margin-top: 27px;
      }
    }
  }
}
</style>
